/**
 * Add a :icontains selector to jQuery to allow case-insensitive
 * :contains selection.
 */
jQuery.expr[':'].icontains = jQuery.expr.createPseudo(function (arg) {
  return function (elem) {
    // Match any text followed by any spaces/newlines followed by
    // a number in parentheses, with an optional comma to separate
    // the thousands digits
    // ex: Apparel (1,234)
    let regex = /(.+)[\s\S]+\([\d,]+\)/;
    let text = (elem.textContent || '').trim();
    let matches = text.match(regex);
    if (matches === null) {
      return false;
    }

    // Match the facet text (without facet counts) against the search term
    return matches[1].toUpperCase().indexOf(arg.toUpperCase()) >= 0;
  };
});

/**
 * jQuery plugin to handle facet filtering.
 */
$.fn.facetSearch = function (options) {
  return this.each(function (index, element) {
    let settings = $.extend({
      keyPressTimer: undefined,
      formId: $(element).data('facetFormId')
    }, options);
    $(element).on('keyup', () => {
      clearTimeout(settings.keyPressTimer);
      settings.keyPressTimer = setTimeout(function () {
        let formId = settings.formId;
        if (!formId.startsWith('#')) {
          formId = `#${formId}`;
        }
        let $facetList = $(formId).find('ul');
        $('#no-results').remove();
        $('.sb-list').find('.sb-list__letter').show();
        let searchTerm = element.value;
        if (!searchTerm) {
          // The search term filter was removed. Show all of
          // the facets and the brand headings
          $('#brand-finder').find('.sb-list__letter').show();
          $facetList.show();
          $facetList.find('li').show();
          return;
        }
        $facetList.find(`li:not(:icontains("${searchTerm}"))`).hide().end().find(`li:icontains("${searchTerm}")`).show().parentsUntil('form').show();
        let visible = $facetList.find('li:visible').length;
        if (visible === 0) {
          // No facets matched the search term. Display a message
          // to the user.
          $('.sb-list').prepend('<div id="no-results" class="pb-3">No results found.</div>');
        }
        //hide individual lists if they have no results
        $('.sb-list__brand-list').each(function (index, element) {
          let $facets = $(element);
          let visible = $facets.find('li:visible').length;
          if (visible === 0) {
            $facets.prev('.sb-list__letter').hide();
            $facets.hide();
          }
        });
      }, 200);
    });
  });
};
$(function () {
  $('input[data-facet-filter]').facetSearch();
});
$(function () {
  let brandLookup = $('#brand-lookup'),
    spinner = new Spinner();
  if (brandLookup.length) {
    let data = {
      customId: $('input[name="customId"]').val(),
      pageUrl: $('input[name="pageUrl"]').val()
    };
    return $.ajax({
      url: '/top-brands.json',
      cache: true,
      data: data,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      timeout: 15000,
      beforeSend: function () {
        DK.displayBlocker(brandLookup);
        spinner.spin(brandLookup.get()[0]);
      },
      complete: function () {
        DK.hideBlocker(brandLookup);
        spinner.stop();
      }
    }).done(function (data) {
      brandLookup.replaceWith(data.brandsHTML);
      $(brandLookup.selector).find('input[type=search]').facetSearch();
    });
  }
});